export default (texts, translate = t => t) => {
  if (!texts) {
    return {};
  }
  return Object.entries(texts).reduce((acc, [k, v]) => ({
    ...acc,
    [k]: translate(v)
  }), {});
};
//# sourceMappingURL=getTranslatedTexts.js.map